import React from 'react'
import { Modal } from 'react-bootstrap'


const SmallCenterModal = ({ show, closeModal, children, dialogClassName, size, backdropClassName }) => {
    return (
        <Modal show={show} size={size || 'md'} onHide={closeModal} backdrop="static" centered className={dialogClassName} backdropClassName={backdropClassName}>
            {children}
        </Modal>
    )
}

export default SmallCenterModal